import { _longPressTypes, LongPressWrapper, LPW } from 'global/wrappers/LongPressWrapper'
import _ from 'lodash'
import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { Icon } from 'semantic-ui-react'
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext'
import { uniqueKey } from '../../../../global/common/keys'
import { gEnums } from '../../../../global/enums/globalEnums'
import { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext'
import { SportsRtMatchContext } from '../../cnr/contexts/SportsRtMatchContext'
import { matchScheduleTypes, SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext'
import { sportsShowTypes } from '../../cnr/reducers/SportsSeasonReducer'
import TeamMatchCompare from '../../create/subs/TeamMatchCompare'
import { matchCalcs } from '../../helpers/match'
import SportsSchedulesProvider from '../schedule/SportsSchedules'
import MatchOveriew from './MatchOveriew'
import { MatchPointHistory } from './MatchPointHistory'
import MatchRealtimeScoring, { matchScoreTypes } from './MatchRealtimeScoring'
import MatchOptionsSquares from './MatchOptionsSquares'
import MatchScoreTable from './MatchScoreTable'
import MatchSidebar from './MatchSidebar'
import MatchPredication from './MatchPredication'
import MatchVote from './MatchVote'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import usePageNavigation from 'global/cnr/contexts/useHelpers/usePageNavigation'
import { useStyles } from 'global/cnr/contexts/useHelpers/useStyles'

const _noResultCaption = 'No Results'

const _icons = {
  home: 'home',
  away: 'bus',
  time: 'clock outline',
  date: 'calendar outline',
  location: 'map marker alternate',
}

export const MatchSummaryContext = createContext();

const MatchSummary = (props) => {

  const upn = usePageNavigation()
  const { setStyleAndClass } = useStyles()

  const { componentContexts } = props ?? {}
  const latestMatchesCount = 5

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper } = appUserAccess ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { appUser_state, paps_state } = states
  const { appUser } = appUser_state ?? {}
  const { loggedIn } = appUser ?? {}
  const { pathViews } = paps_state ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { matches_info, useAppDarkMode, currentSeason_info, sportsShowType, details_info } = sportsSeason_state ?? {}
  const { gameScoringType, gameAllowTies, _sportsModeSport } = currentSeason_info ?? {}
  const { matches, matches_playoffs, matches_realtime } = matches_info ?? {}
  const { details } = details_info ?? {}
  const { showPredictions, allowMatchVote } = details ?? {}

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state } = sportsMatchContext ?? {}
  const { match_true, matchAllows, matchDayMatchData } = sportsMatch_state ?? {}
  const { edit: _allowEdit_match, scores: _allowEdit_scores, scores_p: _allowEdit_scores_p, matchAccessLevel } = matchAllows ?? {}
  const { match_dy } = matchDayMatchData ?? {}

  const _allowEditScores = _allowEdit_scores || _allowEdit_scores_p

  //sportsRtMatchContext
  const sportsRtMatchContext = useContext(SportsRtMatchContext)
  const { sportsRtMatch_state, sportsRtMatch_handlers } = sportsRtMatchContext ?? {}
  const { showRealtimeScoring } = sportsRtMatch_state ?? {}
  const { handleShow_rtMatch } = sportsRtMatch_handlers ?? {}

  const matchRealTime = useMemo(() => {
    return matches_realtime?.[match_true?._itemKey] || null;
  }, [matches_realtime, match_true?._itemKey]);


  const { _itemKey, _status, _resultsStatus, key, home, away, pending, startDate, startTime, sections, levels, isPlayoff, poolKey, location } = match_true ?? {}
  const { resultResults, scoreType } = _resultsStatus ?? {}
  const { complete, scoreDisplays, players } = resultResults || {}
  const { isMatchDayResult } = _status ?? {}
  const { name: location_name } = location ?? {}

  let matchTeamsKeys = []
  if (away && away.id) { matchTeamsKeys.push(away.id) }
  if (home && home.id) { matchTeamsKeys.push(home.id) }

  const _sectionCaption = isPlayoff && poolKey ? _.startCase(poolKey) : _.startCase(sections)

  const styleAndClass = setStyleAndClass({ item: gEnums.projectStyles.actionButton })

  const { normal: sd_normal } = scoreDisplays ?? {}

  const [match_result_realtime, setMatch_result_realtime] = useState()
  const { realTimeMatch, realTimeScorer } = match_result_realtime ?? {}

  useEffect(() => {
    switch (sportsShowType) {
      case sportsShowTypes.realtimeMatch:
        handleShow_rtMatch()
        break;
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sportsShowType]);

  useEffect(() => {
    let tm = matches && matches[pathViews.matches] ? matches[pathViews.matches] : null
    if (!tm) { tm = matches_playoffs && matches_playoffs[pathViews.matches] ? matches_playoffs[pathViews.matches] : {} }
    if (tm) {
      matchCalcs.calcVballMatch(tm, gameScoringType)
      matchCalcs.calcVballMatch_display(tm, gameScoringType)
      // sportsMatch_handlers.handleSet_trueMatch(tm, match_dy)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matches, matches_playoffs, match_dy]);

  useEffect(() => {
    if (matches_realtime) {
      const realtimeMatches = matches_realtime ? matches_realtime[key] : {}
      const _allResults = []
      let realTimeScorer;
      if (realtimeMatches) {
        Object.keys(realtimeMatches).forEach(rmKey => {
          const match_rt = realtimeMatches[rmKey]
          const { displayName, results } = match_rt ?? {}
          realTimeScorer = displayName
          _allResults.push(results)
        })
        if (_allResults && _allResults.length > 0) {
          setMatch_result_realtime({ realTimeMatch: _allResults[0], realTimeScorer })
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [matches_realtime, _itemKey]);

  const handleClick_team = (team) => team && upn.handleNav_item({ key: 'teams' }, team?._itemKey || team?.id)

  const handleShowMatchScoreTable = (e) => {
    e && e.preventDefault()
    e && e.stopPropagation()
    const opts = { sportsShowType: sportsShowTypes.updateResults, matchKey: _itemKey }
    sportsSeason_handlers.handleShow_sportsElem(opts)
  }

  const icon = (name) => <Icon name={name} color={'blue'} size={'small'} />

  const matchPlayers = () => players ? <div className={'summary-split'}>
    <div className={'matches-latest-team'}>Team 1</div>
    <div className={'matches-latest-team'}>Team 2</div>
  </div> : 'No Top Players Selected'

  const overview = () => <div className={'team-overview ms'}>

    {matchRealTime && <MatchPointHistory matchRealTime={matchRealTime} />}

    {complete && <MatchOveriew
      useAppDarkMode={useAppDarkMode}
      caption={'Top Players'}
      content={matchPlayers()}
      cn={'match-players'}
    />}

    {!complete && showPredictions && <Wrapper
      header={'Match Prediction'}
      content={<MatchPredication match={match_true} />}
      wrapperType={wrapperTypes.padded}
    ></Wrapper>}

    {allowMatchVote && <Wrapper
      header={'Who will win?'}
      content={<MatchVote match={match_true} />}
      wrapperType={wrapperTypes.paddedContent}
    ></Wrapper>}

    <Wrapper
      header={'Common Matches'}
      content={<TeamMatchCompare matchTeamsKeys={matchTeamsKeys} inViewer={true} contentOnly={true} sportsShowType={sportsShowTypes.compareBoth} />}
      wrapperType={wrapperTypes.padded}
    ></Wrapper>

    <Wrapper
      header={'Team Form'}
      content={<MatchOveriew
        content={<div className={'summary-split'}>
          <div className={'matches-latest-team'}><SportsSchedulesProvider forSummary={true} matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.levelOverviewMatches} matchScheduleType={matchScheduleTypes.latest} componentContexts={componentContexts} latestMatchesCount={latestMatchesCount} forOverview={true} teamKey={away.id} /></div>
          <div className={'matches-latest-team'}><SportsSchedulesProvider forSummary={true} matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.levelOverviewMatches} matchScheduleType={matchScheduleTypes.latest} componentContexts={componentContexts} latestMatchesCount={latestMatchesCount} forOverview={true} teamKey={home.id} /></div>
        </div>}
        wrapperType={wrapperTypes.paddedContent}
      />}
    ></Wrapper>

    <Wrapper
      header={'Common Opponents'}
      content={<TeamMatchCompare matchTeamsKeys={matchTeamsKeys} inViewer={true} contentOnly={true} />}
      wrapperType={wrapperTypes.padded}
    ></Wrapper>

  </div>

  // const getScoreIcon = () => {
  //   if (_allowEdit_scores) {

  //   } else if (_allowEdit_scores_p) {

  //   }
  // }

  // const content_scoreDisplay = () => {
  //   if (!results && _allowEditScores) {
  //     return <div className='match-display-update'>
  //       <div><Icon name='user' color='blue'></Icon></div>
  //       <div>Update Score</div>
  //       <div><Icon name='edit' color='blue'></Icon></div>
  //     </div>
  //     return 'Update Score'
  //   }
  //   return sd_normal || _noResultCaption
  // }

  const match_summary = (_home, _away) => {
    return <LPW
      itemData={match_true}
      longPressType={_longPressTypes.match}
      longPressModal={{ content: <MatchOptionsSquares match_true={match_true} /> }}
      disallowLpw={true}
    >
      <div className={'ms-summary'}>
        <div key={uniqueKey('ms', 'mc', 1)} className={'ms-home'} onClick={() => { handleClick_team(home) }}>{_home.name}{icon(_icons.home)}</div>
        <div key={uniqueKey('ms', 'mc', 2)} className={'ms-away'} onClick={() => { handleClick_team(away) }}>{icon(_icons.away)}{_away.name}</div>
        <div key={uniqueKey('ms', 'mc', 3)} className={'ms-home-ls'}> {_home?.levels + ' - ' + _.startCase(_home?.sections)}</div>
        <div key={uniqueKey('ms', 'mc', 4)} className={'ms-away-ls'}> {_away?.levels + ' - ' + _.startCase(_away?.sections)}</div>
        <div key={uniqueKey('ms', 'mc', 5)} className={'ms-date'}>{icon(_icons.date)}{startDate}</div>
        <div key={uniqueKey('ms', 'mc', 6)} className={'ms-time'}>{icon(_icons.time)}{startTime}</div>
        <div key={uniqueKey('ms', 'mc', 7)} className={'ms-level'}>{'Level: '}{levels}</div>
        <div key={uniqueKey('ms', 'mc', 8)} className={'ms-section'}>{_sectionCaption}</div>
        <div key={uniqueKey('ms', 'mc', 9)} className={'ms-location'}>{icon(_icons.location)}{location_name ? location_name : _home.name}</div>
        {/* <div key={uniqueKey('ms', 'mc', 10)} className={resultCn} onClick={(e) => { _allowEdit_scores && handleShowMatchScoreTable(e) }}>{content_scoreDisplay()}</div> */}
        {home && away && <div key={uniqueKey('ms', 'mc', 11)} className={'ms-score'}><MatchScoreTable /></div>}
      </div>

    </LPW>
  }

  const matchContent = () => {

    let resultCn = 'ms-result ' + scoreType

    if (_allowEdit_scores) { resultCn += ' aame' }
    if (_allowEdit_scores_p) { resultCn += ' aame' }
    if (matchAccessLevel) { resultCn += ' mal-' + matchAccessLevel }
    if (isMatchDayResult) { resultCn += ' mdr' }

    let _home = home
    let _away = away
    if (!_home && pending?.home) {
      _home = pending.home
    }
    if (!_away && pending?.away) {
      _away = pending.away
    }

    return _home && _away ?
      <div className='ms-summary-full'>
        {match_summary(_home, _away)}
        <MatchSummaryContext.Provider value={{ matchSummary_state: { isSummary: true } }}>
          {home && away && overview()}
        </MatchSummaryContext.Provider>
      </div>
      : <div>Pending</div>
  }

  const sidebar = () => <MatchSidebar
    allowPopup={loggedIn && _allowEdit_match}
    content={matchContent()}
    handleShowPopupContents={handleShow_rtMatch}
    sidebarContent={<MatchRealtimeScoring
      match_edit={match_true}
      smatchScoreType={matchScoreTypes.realtime}
      viewKey={match_true.key}
    />}
    styleAndClass={styleAndClass}
    visible={showRealtimeScoring}
  />

  return match_true ? sidebar() : <div></div>

}

export default MatchSummary